import { useQuery } from '@tanstack/react-query'
import axios from 'axios'
import { legacyQueryOptions } from '@/lib/query-defaults'

const locationSources = [
  `https://api.ipdata.co?api-key=03290aee1283e377d43b7c5323c9aeca245b285a0539d8c6d893732b`,
  'https://ipapi.co/json/',
  'https://ipwho.is/',
  'https://ipinfo.io/json/',
  'http://ip-api.com/json/'
]

const fetchLocation = async () => {
  for (const url of locationSources) {
    try {
      const res = await axios.get(url)
      const data = res.data

      // Tratamento para diferentes estruturas
      if (data && (data.city || data.country || data.region)) {
        // Padroniza os dados
        return {
          city: data.city || '',
          region: data.region || data.regionName || '',
          country: data.country || data.country_name || '',
          zip: data.postal || data.zip || '',
          lat: data.latitude || data.lat || (data.loc && data.loc.split(',')[0]) || '',
          lon: data.longitude || data.lon || (data.loc && data.loc.split(',')[1]) || '',
          ip: data.ip || data.ipAddress || data.query || ''
        }
      }
    } catch (err) {
      continue // tenta o próximo serviço
    }
  }

  throw new Error('Todos os serviços de localização falharam.')
}

export function useFetchLocation() {
  return useQuery({
    ...legacyQueryOptions,
    queryKey: ['location'],
    queryFn: fetchLocation,
    retry: false
  })
}
